export const TOGGLE_HEADER = "TOGGLE_HEADER";

export const toggleHeader = () => ({
    type: TOGGLE_HEADER
})